import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { OperadoraDeMaquinaService } from '../../core/services/operadora-de-maquina.service';

@Injectable()
export class OperadorasInativasResolver implements Resolve<OperadoraDeMaquina[]> {
    constructor(private operadoraService: OperadoraDeMaquinaService) {}

    resolve() {
        return this.operadoraService.obterInativas()
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/shared/operadoras-inativas.resolver.ts